import type { Channel } from 'phoenix';
import { useEffect, useRef } from 'react';

const TIMEOUT = 15 * 60 * 1000;
const EVENTS = ['touchstart', 'mousemove', 'keypress'];
// eslint-disable-next-line import/no-unused-modules -- expose for testing
export const INACTIVITY_CHECK_INTERVAL = 10 * 1000;

const useInactivityObserver = (channel: Channel | null) => {
  const isActiveRef = useRef(true);
  const lastActivityRef = useRef(Date.now());

  useEffect(() => {
    if (!channel) return undefined;

    const interval = setInterval(() => {
      if (
        isActiveRef.current &&
        Date.now() - lastActivityRef.current > TIMEOUT
      ) {
        isActiveRef.current = false;
        channel.push('meta', { active: false });
      }
    }, INACTIVITY_CHECK_INTERVAL);

    const handleActivity = () => {
      lastActivityRef.current = Date.now();

      if (!isActiveRef.current) {
        isActiveRef.current = true;
        channel.push('meta', { active: true });
      }
    };

    EVENTS.forEach((event) => {
      document.addEventListener(event, handleActivity, { passive: true });
    });

    return () => {
      clearInterval(interval);

      EVENTS.forEach((event) => {
        document.removeEventListener(event, handleActivity);
      });
    };
  }, [channel]);
};

export default useInactivityObserver;
